export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://app.gostylu.com';



/** WEBPACK FOOTER **
 ** ./src/constants/api.js
 **/